<div class="h-xl-100">
  <div class="card-body">
    <!-- Header -->
    <div class="d-flex flex-stack">
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <h1
          class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-1"
        >
          {{ "APP.COURSES" | translate }}
        </h1>
        <span class="text-muted fs-7">
          {{ "APP.PARENT_COURSE" | translate }}
        </span>
      </div>
    </div>

    <div class="separator my-4"></div>

    <!-- Search -->
    <section class="col-12 pt-6" [formGroup]="form">
    <!-- One field, one action, sharing a row.
         The two "input + button" pairs on the parent screens were built
         differently: this one had the button overlapping the field's right
         border, the other had it floating a gap away as a circle. Same
         control, same shape now. -->
    <div class="field-row mb-6">
      <div class="field-row__field">
        <app-input
          name="keywords"
          placeholder="APP.SEARCH_COURSE"
          formControlName="keywords"
          [labelMode]="LabelMode.NO_LABEL"
        ></app-input>
      </div>
      <button
        class="btn btn-icon btn-light-primary field-row__action"
        [attr.aria-label]="'APP.SEARCH_COURSE' | translate"
        [attr.title]="'APP.SEARCH_COURSE' | translate"
        (click)="fetchData()"
      >
        <app-keenicon name="magnifier" class="fs-1 svg svg-icon"></app-keenicon>
      </button>
    </div>
    </section>

    <!-- Course List -->
    <section class="col-12">
      <div class="row g-6 g-xl-6">
        @if (isLoading()) {
        <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
        <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
        } @else { @for (item of parentCourses(); track $index) {
        <div
          class="col-md-6 col-xxl-4"
          data-testid="parent-course-card"
          (click)="item.student ? open(item) : ''"
        >
          <div class="card shadow-none">
            <div class="card-body">
              <!-- Image -->
              <div class="col-sm-12 mb-4 cursor-pointer">
                <img
                  [src]="
                    item.course_image_url
                      ? fileUrl + item.course_image_url
                      : './assets/media/svg/files/blank-image.svg'
                  "
                  class="mh-175px col-12 h-175px rounded bg-light object-fit-cover"
                />
              </div>

              <!-- Name -->
              <div class="d-flex flex-column mb-2">
                <a class="fs-5 fw-bold h-20px mb-1 text-gray-800 mb-2">
                  {{ item.course_name }}
                </a>
                <div>
                  @if (item.student) {
                  <div class="badge badge-danger fw-semibold p-2">
                    {{ "APP.WAIT_ACTIVE" | translate }}
                  </div>
                  }@else {

                  <div class="badge badge-light fw-semibold text-gray-600 p-2">
                    {{ "APP.INACTIVE" | translate }}
                  </div>
                  }
                </div>
              </div>

              <div class="separator my-4"></div>

              <!-- Action -->
              <div
                class="d-flex flex-column justify-content-end flex-wrap mt-2 h-60px"
              >
                @if (!item.student) {
                <button
                  class="btn btn-sm btn-outline btn-outline-info btn-active-info fw-bold w-100"
                  data-testid="give-course"
                  (click)="open(item)"
                >
                  {{ "APP.GIVE_COURSE" | translate }}
                </button>
                } @else { @if (item.student.length > 1) {
                <span class="mb-2 text-gray-800">
                  {{ "APP.RECEIVED_STUDENT" | translate }}
                </span>
                <div class="symbol-group symbol-hover mb-1">
                  @for (student of item.student; track $index) {
                  <div
                    class="symbol symbol-circle symbol-30px"
                    [ngbTooltip]="student.student_full_name"
                  >
                    @if(student.student_image_url){
                    <!-- `student.student_image_url` is truthy here by the
                         `@if` itself, so the old `: blank.png` fallback in
                         this binding never actually rendered — the `@else`
                         below (an initial) was already what showed instead. -->
                    <img
                      [src]="fileUrl + student.student_image_url"
                      class="object-fit-cover"
                    />
                    }@else{
                    <span
                      class="symbol-label bg-warning text-inverse-warning fw-bold"
                    >
                      {{ student.student_full_name[1] }}
                    </span>
                    }
                  </div>
                  }
                </div>
                }@else{
                <span class="mb-2 text-gray-800">{{
                  "APP.RECEIVED_STUDENT" | translate
                }}</span>
                <div class="d-flex align-items-center gap-3">
                  <div class="symbol-group symbol-hover mb-1">
                    <div class="symbol symbol-circle symbol-30px">
                      @if(item.student[0].student_image_url){
                      <img
                        [src]="fileUrl + item.student[0].student_image_url"
                        class="object-fit-cover"
                      />
                      }@else{
                      <span
                        class="symbol-label bg-warning text-inverse-warning fw-bold"
                      >
                        {{ item.student[0].student_full_name[0] }}
                      </span>
                      }
                    </div>
                  </div>
                  <span class="fs-6 text-gray-700">{{
                    item.student[0].student_full_name
                  }}</span>
                </div>

                } }
              </div>
            </div>
          </div>
        </div>
        } @empty {
        <!-- Searching this library for something that is not in it used to
             empty the card completely: the page jumped from its subtitle
             straight to the footer with no message at all. -->
        <div class="col-12">
          <div class="empty-state" data-testid="parent-courses-empty">
            <span class="empty-state__mark">
              <app-keenicon name="book-open" class="fs-2tx"></app-keenicon>
            </span>
            <p class="empty-state__title">{{ "APP.PARENT_COURSES_EMPTY" | translate }}</p>
            <p class="empty-state__body">{{ "APP.PARENT_COURSES_EMPTY_HINT" | translate }}</p>
            <a class="btn btn-primary" routerLink="/courses">{{ "MENU.COURSES" | translate }}</a>
          </div>
        </div>
        } }
      </div>
    </section>
  </div>
</div>

<!-- Skeleton -->
<ng-template #skeletonItem>
  <div class="col-md-6 col-xxl-4">
    <div class="card shadow-none">
      <div class="card-body">
        <div class="skeleton w-100 h-175px mb-4"></div>
        <div class="skeleton w-100 h-20px mb-4"></div>
        <div class="skeleton w-60px h-20px"></div>
        <div class="separator my-4"></div>
        <div class="skeleton w-50 h-20px mb-2"></div>

        <div class="d-flex align-items-center gap-3">
          <span class="skeleton rounded-circle w-30px h-30px"></span>
          <span class="skeleton w-125px h-20px"></span>
        </div>
      </div>
    </div></div
></ng-template>
